// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1idwl","title":"styles_title__2M3KE"};